import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faEllipsisH,
    faSearch,
    faSpinner,
    faTimes
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faEllipsisH,
    faSearch,
    faSpinner,
    faTimes
)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
